"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleIcon = exports.MaerskLogoContainer = exports.MaerskLogo = exports.Components = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Box = _interopRequireDefault(require("../Box"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
const Container = (0, _styledComponents["default"])(_Box["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  height: 100%;\n  min-width: ", ";\n  width: ", ";\n  position: fixed;\n  box-shadow: ", ";\n  transition: all 0.3s ease-in-out;\n  background-color: ", ";\n"])), _ref => {
  let {
    isExpanded,
    minWidth
  } = _ref;
  return isExpanded ? minWidth ? "".concat(minWidth, "px") : '264px' : minWidth ? "".concat(minWidth, "px") : '64px';
}, _ref2 => {
  let {
    isExpanded
  } = _ref2;
  return isExpanded ? '264px' : '64px';
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.boxShadows.card['4'];
}, _ref4 => {
  let {
    theme,
    themeMode
  } = _ref4;
  return themeMode === 'dark' ? theme.colors.primary.blue['900'] : '';
});
const Layout = (0, _styledComponents["default"])(_Box["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  height: inherit;\n  position: relative;\n"])));
const Header = (0, _styledComponents["default"])(_Box["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n"])));
const MaerskLogoContainer = exports.MaerskLogoContainer = (0, _styledComponents["default"])(_Box["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  align-items: center;\n  justify-content: center;\n  color: ", ";\n  width: 100%;\n  margin-top: ", ";\n  cursor: pointer;\n"])), _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.colors.functional.grey['50'];
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.space['24'];
});
const MaerskLogo = exports.MaerskLogo = _styledComponents["default"].img(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  width: 160px;\n  height: ", ";\n"])), props => props.isCollapsed ? '28px' : '36px');
const ToggleIcon = exports.ToggleIcon = (0, _styledComponents["default"])(_Box["default"])(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  padding: ", ";\n  position: absolute;\n  top: ", ";\n  bottom: ", ";\n  box-shadow: 0px 0px ", " rgba(0, 0, 0, 0.3);\n  right: -14px;\n  background-color: ", ";\n  border-radius: ", ";\n  border: ", ";\n  display: flex;\n  color: ", ";\n  cursor: pointer;\n"])), _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.space['4'];
}, _ref8 => {
  let {
    theme,
    toggleIconPosition
  } = _ref8;
  return toggleIconPosition === 'top' ? theme.space['56'] : 'unset';
}, _ref9 => {
  let {
    theme,
    toggleIconPosition
  } = _ref9;
  return toggleIconPosition === 'bottom' ? theme.space['56'] : 'unset';
}, _ref10 => {
  let {
    theme
  } = _ref10;
  return theme.space['4'];
}, _ref11 => {
  let {
    theme,
    themeMode
  } = _ref11;
  return themeMode === 'dark' ? theme.colors.primary.blue['900'] : theme.colors.functional.grey['50'];
}, _ref12 => {
  let {
    theme
  } = _ref12;
  return theme.borderRadius['xxl'];
}, _ref13 => {
  let {
    theme,
    themeMode
  } = _ref13;
  return themeMode === 'dark' ? "1px solid ".concat(theme.colors.functional.grey['50']) : null;
}, _ref14 => {
  let {
    theme,
    themeMode
  } = _ref14;
  return themeMode === 'dark' ? theme.colors.functional.grey['50'] : null;
});
const Components = exports.Components = {
  Container,
  Layout,
  Header,
  MaerskLogoContainer,
  MaerskLogo,
  ToggleIcon
};